import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=f2ca82d4&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=f2ca82d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ca82d4",
  null
  
)

export default component.exports